export default function setResponse(errorMessage) {
  return {
    isError: !!errorMessage,
    message: errorMessage,
  };
}
